export function getPageCopy(vm, key) {
  const locale =
    (vm && vm.$i18n && vm.$i18n.locale) ||
    localStorage.getItem("lang") ||
    "en_us";
  const localeMessage =
    (vm && vm.$i18n && vm.$i18n.getLocaleMessage(locale)) || {};
  const zhMessage =
    (vm && vm.$i18n && vm.$i18n.getLocaleMessage("zh_cn")) || {};

  return (((localeMessage.pages || {})[key]) || ((zhMessage.pages || {})[key]) || {});
}
